class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    // PC（マウス操作）はホバーで開閉。タッチ端末・キーボードは従来どおりクリック
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
      this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
      this.mainDetailsToggle.querySelector('summary').addEventListener('click', (event) => {
        // マウスのクリック（detail > 0）ではホバーで開いた状態を閉じない
        if (event.detail > 0 && this.mainDetailsToggle.open) event.preventDefault();
      });
    }
  }

  onMouseEnter() {
    clearTimeout(this.hoverCloseTimer);
    this.cancelClosing();
    if (this.mainDetailsToggle.open) return;
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
  }

  onMouseLeave() {
    clearTimeout(this.hoverCloseTimer);
    this.hoverCloseTimer = setTimeout(() => this.closeWithFade(), 150);
  }

  // フェードアウト（snippets/tata-header-styles.liquid の .tata-submenu-closing）が終わってから閉じる
  closeWithFade() {
    if (!this.mainDetailsToggle.open || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.close();
      return;
    }
    this.mainDetailsToggle.classList.add('tata-submenu-closing');
    const finish = () => {
      this.cancelClosing();
      this.close();
    };
    this.onClosingAnimationEnd = (event) => {
      if (event.target === this.content) finish();
    };
    this.content.addEventListener('animationend', this.onClosingAnimationEnd);
    this.closingFallbackTimer = setTimeout(finish, 400);
  }

  cancelClosing() {
    clearTimeout(this.closingFallbackTimer);
    if (this.onClosingAnimationEnd) {
      this.content.removeEventListener('animationend', this.onClosingAnimationEnd);
      this.onClosingAnimationEnd = null;
    }
    this.mainDetailsToggle.classList.remove('tata-submenu-closing');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
